<template>
  <el-input class="sh-input" v-bind="$attrs" :clearable="clearable" v-on="$listeners">
    <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
  </el-input>
</template>

<script>
export default {
  name: 'ShInput',
  props: {
    clearable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style></style>
